import * as React from "react";
import {observer, inject} from "mobx-react";
import Modal from "@components/react-responsive-modal/modal";
import GridBaseEditor from "@components/Grid/GridBaseEditor";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

@inject("store")
@observer
export default class BerikssonGrid extends React.Component {
    constructor(props) {
        super(props);

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.modalRef = React.createRef();

        this.state = {modalOpen: false}
    }

    componentDidMount() {

    }

    componentDidUpdate() {

    }

    openModal(e) {
        e.preventDefault()
        this.setState({modalOpen: true});
    }

    closeModal(e) {
        e.preventDefault()
        const returnUrl = this.props.returnUrl;
        if (returnUrl) {
            const navigation = this.props.store.navigation;
            navigation.navigateToSiteUrl(navigation.mainTree, this.props.returnUrl);
        } else {
            this.setState({modalOpen: false});
        }

    }

    renderRows(rows) {
        return rows.map((row, rowIndex) => {
            // Look for row-settings
            let rowConfig = null;
            if (row.config && row.config.class) {
                if (row.config.class.indexOf("mobile_40_60") > -1) {
                    rowConfig = rowConfigs.find(x => x.name === "mobile_40_60");
                }
            }

            let styles = null;
            let backgroundImage = null;
            if (row.styles) {
                backgroundImage = row.styles["background-image"];
                //console.log("styles", row.styles, backgroundImage);
                styles = {
                    backgroundImage: backgroundImage
                };
            }

            const rowClasses = [
                "row", "grid-row",
                (row.config && row.config.class) ? row.config.class : null
            ];
            var rowKey = row.id ? row.id : rowIndex;

            if (row.config) {
                var keys = Object.keys(row.config);
                var filteredKeys = keys.map(k => {
                    if (k === "class") {
                        return null;
                    }

                    if (row.config[k] === "1") {
                        return k;
                    }

                    return null;
                }).filter(v => v !== null);

                rowClasses.push.apply(rowClasses, filteredKeys);
            }
            return (
                
                    <div className="container-fluid" key={rowKey} >
                        <div className={rowClasses.join(" ")}
                             style={{
                                 backgroundImage: backgroundImage
                             }}>

                            {row.areas.map((area, areaIndex) => {
                                    //hasContent = true;

                                    const mobileCols = row.config && row.config.ignoreMobile == 1 ? `col-${area.grid}` : "col-12";

                                    const areaClasses = [
                                        area.grid <= 4 && row.areas.length > 2 ? ("col-lg-" + area.grid) : ("col-md-" + area.grid),
                                        rowConfig ? rowConfig.cols[areaIndex] : mobileCols,
                                        (area.config && area.config.class) ? area.config.class : null
                                    ];

                                    if (area.config) {

                                        var keys = Object.keys(area.config);
                                        var filteredKeys = keys.map(k => {
                                            if (k === "class") {
                                                return null;
                                            }

                                            if (area.config[k] === "1") {
                                                return k;
                                            }

                                            return null;
                                        }).filter(v => v !== null);

                                        areaClasses.push.apply(areaClasses, filteredKeys);
                                    }


                                    return (
                                        <div key={areaIndex}
                                             className={areaClasses.join(" ")}>
                                            {areaClasses.indexOf("vertical-center") > -1 ?
                                                <div className="vertical-center-container">
                                                    {area.controls.map((control, controlIndex) => (
                                                        <React.Fragment key={controlIndex}>
                                                            {(control != null &&
                                                                control.editor != null &&
                                                                control.editor.view != null)
                                                                ? <GridBaseEditor {...this.props}
                                                                                  key={"editor_" + controlIndex}
                                                                                  control={control}
                                                                                  product={this.props.pickProduct}
                                                                />
                                                                : ""}
                                                        </React.Fragment>
                                                    ))}</div> :
                                                <React.Fragment>{area.controls.map((control, controlIndex) => (
                                                    <React.Fragment key={controlIndex}>
                                                        {(control != null &&
                                                            control.editor != null &&
                                                            control.editor.view != null)
                                                            ? <GridBaseEditor {...this.props}
                                                                              key={"editor_" + controlIndex}
                                                                              control={control}
                                                                              product={this.props.pickProduct}

                                                            />
                                                            : ""}
                                                    </React.Fragment>
                                                ))}</React.Fragment>}
                                        </div>
                                    );
                                }
                            )}
                        </div>
                    </div>
                
            );
        })

    }

    render() {
        const gridJson = this.props.model;
        const readMoreAfterRows = this.props.readMoreAfterRows;
        //console.debug("Grid - RENDER", gridJson, readMoreAfterRows);

        const serverRender = typeof window === 'undefined';
        const rowConfigs = [
            {
                name: "mobile_40_60",
                cols: ['col-4', 'col-8']
            }
        ];


        if (!this.props.model) return null;
        let hasContent = false;
        let firstSectionRendered = false;

        var gridContent =
            gridJson.sections.map((section, sectionIndex) => {
                const sectionCopy = JSON.parse(JSON.stringify(section))

                const renderRows = (!firstSectionRendered && readMoreAfterRows && !isNaN(readMoreAfterRows) && sectionCopy.rows.length > readMoreAfterRows)
                    ? sectionCopy.rows.splice(0, readMoreAfterRows)
                    : sectionCopy.rows.splice(0, sectionCopy.rows.length);
                
                firstSectionRendered = true;

                return [this.renderRows(renderRows),
                    (renderRows && renderRows.length > 0 && sectionCopy.rows && sectionCopy.rows.length > 0) &&  <a className="read-more mb-3" href="" onClick={this.openModal}>Läs mer</a>,
                    sectionCopy.rows.length ?
                        <React.Fragment key={sectionIndex}>
                            
                            <div ref={this.modalRef} className="rmd-modal-dialog"/>

                            {serverRender
                                ? ((readMoreAfterRows === -1 || this.state.modalOpen) && <div key={"modal"}
                                                                                              className="rmd-overlay content-overlay scroll-content">
                                    <div className="rmd-modal rmd-modalCenter content-dialog page-content" role="dialog" aria-modal="true">
                                        <div className="content-dialog-inner">
                                            {this.renderRows(sectionCopy.rows)}
                                        </div>
                                    </div>
                                </div>)
                                : <Modal
                                    key={"modal"}
                                    container={this.modalRef.current}
                                    open={readMoreAfterRows === -1 || this.state.modalOpen}
                                    onClose={(e) => {
                                        this.closeModal(e);
                                    }}
                                    center
                                    showCloseIcon={false}
                                    focusTrapped={false}
                                    scrollClass="scroll-content"
                                    classNames={{
                                        overlay: "content-overlay scroll-content",
                                        modal: "content-dialog page-content",
                                        closeIcon: "content-dialog-closeIcon"
                                    }}
                                    animationDuration={0}
                                >
                                    <button className="close"
                                            onClick={(e) => {
                                                this.closeModal(e);
                                            }}
                                    >
                                        <FontAwesomeIcon icon={["fas", "times"]}
                                                         size="sm"
                                                         className={""}
                                        />
                                        <span>Stäng</span>
                                    </button>

                                    <div className="content-dialog-inner">
                                        {this.renderRows(sectionCopy.rows)}
                                    </div>
                                </Modal>
                            }
                        </React.Fragment>
                        : null

                ];
            });

        return gridContent;
        // if (hasContent) {
        //     return gridContent;
        // } else {
        //     return (null);
        // }
        // 
    }
}